import { Component, OnInit, Inject, Input, InjectionToken } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { Paginate } from '../../search-document-sign/search-document-sign.component';
import { DataSource } from '@angular/cdk/collections';
import {BehaviorSubject, merge, Observable, Subscription} from 'rxjs';
import { DocumentService } from 'src/app/core/services/document.service';
import { debug } from 'util';
import {Message} from '../../../../../../../core/class/message';
import {CommonService} from '../../../../../../../core/services/common.service';
import {tap} from "rxjs/operators";
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import {ResponsiveService} from "../../../../../../../core/services/responsive.service";
import { format } from 'date-fns';

/**
 * The document model.
 */
export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
}

/**
 * document source.
 */
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-sign-digital-document-list',
  templateUrl: './sign-digital-document-list.component.html'
})

/**
 * Sign document list component.
 */
export class SignDigitalDocumentListComponent implements OnInit {
  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  dataSource: any = [];

  tmp: any;

  paginate: Paginate;
  isVContract:boolean=true;

  documents = new Document();

  noOfFiles: 0;
  notifyWarning: string;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'noOfFile',
    // 'memoryStorage',
    // 'serviceTypeName',
    // 'effectiveDate',
    'expireDate',
    // 'createdBy'
  ];
  columnDefinitions = [
    {def: 'STT',showMobile:true},
    {def: 'contractName',showMobile:true},
    {def: 'noOfFile',showMobile:true},
    // {def: 'memoryStorage', showMobile:false},
    // {def: 'serviceTypeName', showMobile:false},
    // {def: 'effectiveDate', showMobile:false},
    {def: 'expireDate',showMobile:false},
    // {def: 'createdBy',showMobile:false},
  ];

  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      signOption: string,
      slotDocuments: any,
      filterSignAll: any
    },
    private router: Router,
    private documentService: DocumentService,
    private message: Message,
    private responsiveService: ResponsiveService,
    private commonService: CommonService,
  ) {
    this.signOption = data.signOption;
    this.slotDocuments = data.slotDocuments;
    this.filterSignAll = data.filterSignAll;
  }

  /**
   * Initialize data.
   */
  ngOnInit() {
    // if (this.commonService.checkEnterpriseType()) {
    //   this.isVContract = false;
    // }
    //
    // if (this.isVContract) {
    //   this.columnDefinitions.splice(-2, 0, {def: 'bctConfirmStatus', showXS: false, showSM: false, showMD: true},);
    //   this.displayedColumns.splice(-2, 0, 'bctConfirmStatus');
    // }
    if (this.signOption === SignDigitalDocumentListComponent.SIGN_ALL) {
      this.loadDocumentsBySignAll();
    } else {
      console.log("slot: " + JSON.stringify(this.slotDocuments));
      const dataSource = this.slotDocuments.value.map(item => ({
        ...item,
        contractName: item.name,
      }));

      const validData = dataSource.filter(x => x.status === 1);
      const notifyWarningStr = this.commonService.format(this.message.getMessage('messages.warning_multi_sign_lot_digital'), dataSource.length - validData.length, dataSource.length, validData.length);
      this.notifyWarning = validData.length === dataSource.length ? '' : notifyWarningStr;
      this.dataSource = validData;
      this.noOfFiles = validData.reduce(function (s, a) {
        return s + a.contractAttachments.length;
      }, 0);
    }
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    this.actions.next(SignDigitalDocumentListComponent.CLOSE_ACTION);
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
    if(this.dataSource.length == 0){
      return
    }
    this.actions.next(SignDigitalDocumentListComponent.CONFIRM_ACTION);
  }

  /**
   * Load document by sign all.
   */
  private loadDocumentsBySignAll() {
    this.documentService.getDigitalDocumentsBySignAll(this.filterSignAll)
      .subscribe(rs => {
        if (rs && rs.data) {
          this.dataSource = rs.data.content.map(item => {
            return {
              ...item,
              contractName: item.name,
              effectiveDate: item.effectiveDate ? format(format(item.effectiveDate, 'MMM DD, YYYY HH:mm:ss A'), 'DD/MM/YYYY') : '',
            }
          });
          this.noOfFiles = this.dataSource.reduce(function (s, a) {
            return s + a.contractAttachments.length;
          }, 0);
        }
      });
  }

}
